
import axios from 'axios';
import { store } from '../store/store';
// import jwt_decode from "jwt-decode";
// import dayjs from 'dayjs'
import { UPDATE_ACCESS_TOKEN } from '../store/actions/types';
import { logout } from '../store/actions/auth';
import { getCsrfToken } from '../store/actions/auth';


// ------------------------------------------------------------------------
// with authorisation
// ------------------------------------------------------------------------
const client = axios.create({
    baseURL: window.location.origin,
    retries: 3, // number of retries
    retryDelay: (retryCount) => {
    //   console.log(`retry attempt: ${retryCount}`);
      return retryCount * 2000; // time interval between retries
    },
    // retryCondition: (error) => {
    // },
});

export const request_interim = ({csrf,...options}) =>{

    client.defaults.headers.common['Authorization'] = `JWT ${store.getState().auth?.access}`
    client.defaults.headers.common['X-CSRFToken'] = csrf;

    let auth_refresh = store.getState().auth?.refresh
    
    const refreshToken = async () => {
        let out_token
        try{
            const res = await axios.post('/api/token/refresh/', 
            { "refresh": auth_refresh})

            let out = res.data
            store.dispatch({
                type: UPDATE_ACCESS_TOKEN,
                payload: out
            })               
            out_token = `JWT ${out?.access}`;
            } catch (err) {
                // Handle Error Here
                console.error(err);
                // store.dispatch(logout())
            }
            return out_token
        }; 

client.interceptors.response.use((response) => {
        return response
    }, async function (error) {
        const originalRequest = error.config;
        // console.log('error.response.status',error.response.status, originalRequest._retry)
        if (((error.response.status === 401 
            // || error.response.status === 403
             ) && 
        (!originalRequest._retry))) {

        const access_token = await refreshToken();
        originalRequest._retry = true;
      
        originalRequest['Authorization'] = 'JWT ' + access_token;

        return client(originalRequest);
        }
        return Promise.reject(error);
    });    

    const onSuccess = response => response
    const onError = error =>{
        return error.response

    }

    return client(options).then(onSuccess).catch(onError)
}


export const request_refreshed = async (api_url, api_method, api_data) => {
   
    // console.log('request_refreshed',api_url,api_address, api_method, api_data)
    let res='noauth';

    const user_id = store.getState().auth?.user?.id;
    if(user_id != null || api_url=='/auth/users/me/'){
    // let csrf_new = store.getState().auth?.csrf;
    let csrf_new =getCsrfToken();


    let input_request;
    if(api_method=='get'){
        input_request={
            url:api_url,
            method: api_method,
            csrf: csrf_new
        }
    }else{
    input_request={
        url:api_url,
        method: api_method,
        data: api_data,
        csrf: csrf_new
    }
    }

    let status=401;
    try{
        res = await request_interim(input_request);
        status = res?.status
    }catch{}

    if(status==401 ){
        try{res = await request_interim(input_request);
            status = res?.status;
        }catch{}
        if( status==401 ){
            store.dispatch(logout())
        }
    }

    if(![200,201]?.includes(status)){
        res = {"status": status, "noconnection":true}
    }
    return res
}
}
// ------------------------------------------------------------------------
// without authorisation
// ------------------------------------------------------------------------
const client_noauth = axios.create({
    // baseURL: api_address,
    retries: 3, // number of retries
    retryDelay: (retryCount) => {
    //   console.log(`retry attempt: ${retryCount}`);
      return retryCount * 2000; // time interval between retries
    },
});

export const request_interim_noauth = ({...options}) =>{

    // client_noauth.defaults.headers.common['X-CSRFToken'] = csrf;

    const onSuccess = response => response
    const onError = error =>{
        return error.response
    }

    return client(options).then(onSuccess).catch(onError)

}


export const request_noauth = async ( api_url, api_method, api_data) => {

    if(getCsrfToken()!=''){
        var config = {
            headers: {
                'Authorization': null,
                'Content-Type': 'application/json',
                "X-CSRFToken" : getCsrfToken()
            }}
      
    }else{

    var config= {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'}
        };
    }

    let res;
    if(api_method=='get'){
    res = await axios.get(
    // api_address+
    window.location.origin+
         api_url, config);
    }else{
        res = await axios.post(
            // api_address+
            window.location.origin+
             api_url, api_data, config);  
    }

    return res
}



export const request_tryauth = async (api_url, api_method, api_data) => {

    let res;

    const user_id = store.getState().auth?.user?.id; 

    if(user_id>0){
    res = await request_refreshed(api_url, api_method, api_data)
    }else{
    res = await request_noauth(api_url, api_method, api_data)
    }
    return res
}


